BoardOrgSelectPermLevelView = require 'app/scripts/views/board-menu/board-org-select-perm-level-view'
BoardSelectOrganizationView = require 'app/scripts/views/board-menu/board-select-organization-view'
PopOver = require 'app/scripts/views/lib/pop-over'

module.exports = class BoardSelectOrganizationForPermChangeView extends BoardSelectOrganizationView

  initialize: (options) ->
    @disableNone = options?.disableNone
    super

  render: ->
    super
    if @disableNone
      @$('.js-submit').addClass('disabled').attr('disabled', 'disabled')

    @

  showOrgBoardVisPerms: (organization, idOrganizationSource) ->
    # we're not in a context where we want to do this, so error instead
    PopOver.pushView
      view: new BoardOrgSelectPermLevelView({ @model, organization, idOrganizationSource, @modelCache })

  submit: (e) ->
    super

  canAddToOrg: (organization) ->
    !organization.isFeatureEnabled('restrictVis') || organization.canSetVisibility('org')

  updateModel: (idOrganizationTarget) ->
    @model.update
      idOrganization: idOrganizationTarget
      'prefs/permissionLevel': 'org'

  orgSelected: ->
    super
    if @disableNone
      if @$('.js-org').val() == ""
        @$('.js-submit').addClass('disabled').attr('disabled', 'disabled')
      else
        @$('.js-submit').removeClass('disabled').removeAttr('disabled')
